import {EndUserSubscriptionModel} from '../../subscription/subscription-list/end-user-subscription.model';
import {EndUserStatus} from './end-user-status-type';

export class EndUserCreditCardAcquirer {
  name: string;
  acquirerType: {
    type: string
  };
}

export class EndUserCreditCard {
  id: number;
  acquirer_hash: string;
  card_hash: string;
  end_user_id: number;
  expiration_month: string;
  expiration_year: string;
  first_six_digits: string;
  last_four_digits: string;
  is_used: boolean;
  main_card: boolean;
  registration_time: number;
  type: 'other' | 'mir' | 'maestro' | 'master-card' | 'visa';
  acquirer: EndUserCreditCardAcquirer;
  acquirerName: string;
  acquirerTypeName: string;
}

export class EndUserComment {
  author: string;
  author_role: string;
  comment: string;
  region_name: string;
  timestamp: number;
}

export interface EndUserOrdersViewDebt {
  number: number;
  penalty: string;
  duration: number;
  status: string;
  total_price: number;
  trip_debt: string;
  unit_name: string;
  unit_type: string;
}

export interface EndUserOrdersViewActive {
  amount_last_financial_operation: string;
  duration: number;
  number: number;
  status: string;
  status_last_financial_operation: number;
  total_price: number;
  unit_name: string;
  unit_type: string;
  unit_type_id: number;
}

export interface EndUserOrdersView {
  debt: Array<EndUserOrdersViewDebt>;
  active: Array<EndUserOrdersViewActive>;
}

export class EndUserTouristRoute {
  name: string;
  period: number;
  price: string;
  currency: string;
  time_finish: number;
  time_start: number;
  tourist_route_id: number;
  region_name: string;
}

export class EndUserImage {
  image: string;
  title: string;
}

export class EndUserPenaltyDebtModel {
  id: number;
  amount: string;
  currency_code: string;
}

export class EndUserModel {
  id: number;
  login: string;
  project_id: number;
  status: EndUserStatus;
  status_extended_registration: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  birth_date: string;
  birth_date_timestamp: number;
  country: string;
  city: string;
  comment: string;
  residence_address: string;
  end_user_photo: string;
  first_page_passport_photo: string;
  registration_date: string;
  registration_date_timestamp: number;
  email: string;
  project_custom_name: string;
  avatar: string;
  currentCurrencyCode: string;
  end_user_avatar: string;
  balanceInCurrency: string;
  last_request_device_vendor: string;
  last_request_device_model: string;
  last_request_client_version: string;
  last_request_os_version: string;
  last_request_os_type: string;
  endUserCreditCard: Array<EndUserCreditCard>;
  subscriptionsView: Array<EndUserSubscriptionModel>;
  commentsView: Array<EndUserComment>;
  touristRouteView: Array<EndUserTouristRoute>;
  endUserOrdersView: EndUserOrdersView;
  automaticBalanceReplenishmentStatus: boolean;
  endUserGroup: {
    id: number;
    name: string;
    description: string;
    project_country_id: number;
    region_id: number;
    user_id: number;
  };
  penaltyDebts: Array<EndUserPenaltyDebtModel>;
  tripDebts: Array<EndUserPenaltyDebtModel>;
  is_anonymous: boolean;
  level_name: string;
}
